<template>
<div class="schematic-wrap">
    <div class="content-schematic">
        <div class="title-box">
            照片示例
            <img @click="close" src="@/assets/images/close-ia.png" alt="">
        </div>
        <div class="tips-box">
            <img src="@/assets/images/1098.png" alt="">
            <span>请拍摄房间整体照片，可看到天花板及地面，勿拍摄房间局部或风口特写照片</span>
        </div>
        <div class="photo-item-box">
            <div class="photo-item">
                <div class="title-box-photo" v-if="type==1">
                    【客厅、餐厅、卧室等房间整体照片】<br/><span>可看到空调风口或新风风口</span>
                </div>
                <div class="title-box-photo" v-else>
                    【客餐厅、卧室、书房等房间整体照片】<br/><span>可看到五恒系统出风口</span>
                </div>
                <div class="img-wrap-sc"  v-if="type==1">
                    <img src="@/assets/images/schematic/sch-101.png" @click="toView(1,0)" alt="">
                    <img src="@/assets/images/schematic/sch-102.png" @click="toView(1,1)" alt="">
                    <img src="@/assets/images/schematic/sch-103.png" @click="toView(1,2)" alt="">
                </div>
                <div class="img-wrap-sc"  v-else>
                    <img src="@/assets/images/schematic/wh-101.png" @click="toView(1,0)" alt="">
                    <img src="@/assets/images/schematic/wh-102.png" @click="toView(1,1)" alt="">
                    <img src="@/assets/images/schematic/wh-103.png" @click="toView(1,2)" alt="">
                </div>
            </div>
            <div class="photo-item">
                <div class="title-box-photo" v-if="type==1">
                    【厨房照片】可看到采暖炉
                </div>
                <div class="title-box-photo" v-else>
                    【设备间照片】可看到完整主机
                </div>
                <div class="img-wrap-sc"  v-if="type==1">
                    <img src="@/assets/images/schematic/sch-104.png" @click="toView(2)" alt="">
                </div>
                <div class="img-wrap-sc"  v-else>
                    <img src="@/assets/images/schematic/wh-104.png" @click="toView(2)" alt="">
                </div>
            </div>
            <div class="photo-item">
                <div class="title-box-photo" v-if="type==1">
                    【其他】可拍摄控制面板或空调外机（二选一）
                </div>
                <div class="title-box-photo" v-else>
                    【线控器照片】<br/>分别在风量、CO₂两种数显状态下拍摄线控器
                </div>
                <div class="img-wrap-sc" v-if="type==1">
                    <img src="@/assets/images/schematic/sch-105.png" @click="toView(3,0)" alt="">
                    <img src="@/assets/images/schematic/sch-106.png" @click="toView(3,1)" alt="">
                </div>
                <div class="img-wrap-sc" v-else>
                    <img src="@/assets/images/schematic/wh-105.png" @click="toView(3,0)" alt="">
                    <img src="@/assets/images/schematic/wh-106.png" @click="toView(3,1)" alt="">
                </div>
            </div>
        </div>
    </div>
    <van-image-preview v-model="imgShow" :closeable="true" :startPosition="lookImgIndex" :images="arrStausImg"></van-image-preview>
</div>
</template>

<script>
export default {
    name: "schematic",
    props:{
        type:{
            type:Number,
            default:1,//2-五恒  1-其他
        }
    },
    data(){
        return{
            imgShow:false,
            lookImgIndex:0,
            arrStausImg:[],
            imgArr1:[require('@/assets/images/schematic/sch-101.png'),require('@/assets/images/schematic/sch-102.png'),require('@/assets/images/schematic/sch-103.png')],
            imgArr2:[require('@/assets/images/schematic/wh-101.png'),require('@/assets/images/schematic/wh-102.png'),require('@/assets/images/schematic/wh-103.png')],
        }
    },
    methods:{
        close(){
            this.$emit('closeSchematic')
        },
        toView(state,index){
            if(this.type==1){
                if(state==1){
                    this.lookImgIndex=index
                    this.arrStausImg=this.imgArr1
                }else if(state==2){
                    this.lookImgIndex=0
                    this.arrStausImg=[require('@/assets/images/schematic/sch-104.png')]
                }else if(state==3){
                    this.lookImgIndex=index
                    this.arrStausImg=[require('@/assets/images/schematic/sch-105.png'),require('@/assets/images/schematic/sch-106.png')]
                }
            }else{
                if(state==1){
                    this.lookImgIndex=index
                    this.arrStausImg=this.imgArr2
                }else if(state==2){
                    this.lookImgIndex=0
                    this.arrStausImg=[require('@/assets/images/schematic/wh-104.png')]
                }else if(state==3){
                    this.lookImgIndex=index
                    this.arrStausImg=[require('@/assets/images/schematic/wh-105.png'),require('@/assets/images/schematic/wh-106.png')]
                }
            }

            this.imgShow=true
        },
    },
}
</script>

<style scoped lang="scss">
.schematic-wrap{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0,0,0,0.6);
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 100px;
    .content-schematic{
        width: 87.2%;
        height: 85%;
        background: #fff;
        overflow: hidden;
        border-radius: 28px;
        .title-box{
            width: 100%;
            height: 128px;
            background: #83A594;
            font-size: 36px;
            color: #FFFFFF;
            line-height: 128px;
            text-align: center;
            position: relative;
            img{
                width: 48px;
                height: 48px;
                position: absolute;
                top: 50%;
                right: 32px;
                transform: translateY(-50%);
            }
        }
        .tips-box{
            width: 100%;
            height: 104px;
            background: #FFFBE8;
            display: flex;
            margin-bottom: 40px;
            padding: 24px 32px;
            img{
                width: 28px;
                height: 28px;
                margin-top: 4px;
            }
            span{
                padding-left: 12px;
                flex: 1;
                font-size: 24px;
                color: #ED6A0C;
            }
        }
        .photo-item-box{
            width: 100%;
            height: calc(100% - 128px - 104px);
            padding-bottom: 24px;
            overflow-y: auto;
            .photo-item{
                padding: 0 32px;
                margin-bottom: 48px;
                .title-box-photo{
                    font-size: 28px;
                    font-weight: 600;
                    color: #2E302F;
                    padding-left: 10px;
                    position: relative;
                    &:before{
                        content: "";
                        width: 6px;
                        height: 28px;
                        background: #2551F0;
                        border-radius: 4px;
                        position: absolute;
                        top: 4px;
                        left: 0;
                    }
                    span{
                        padding-left: 16px;
                    }
                }
                .img-wrap-sc{
                    overflow: hidden;
                    img{
                        width: 100%;
                        margin-top: 24px;
                    }
                }
            }
        }
    }
}
</style>
